import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import classes from 'classnames';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';
import { translatableResourcePath } from '../../utils/helpers';
import './numerical-scale.scss';
import { QuestionHeading } from './question-heading';

export const NumericalScale = observer(
    ({ ui, handleChange, value, answer }) => {
        const { t } = useTranslation('assessment');
        const [showLabels, setShowLabels] = React.useState(true);

        const handleToggle = (event, newValue) => {
            handleChange(newValue);
            if (newValue) {
                hideLabel();
            } else {
                showLabel();
            }
        };

        const showLabel = () => {
            setShowLabels(true);
        };

        const hideLabel = () => {
            setShowLabels(false);
        };

        useEffect(() => {
            showLabel();
        }, [ui]);

        return (
            <div className={classes('assessment')}>
                <div className={'assessment-question'}>
                    {ui.image && (
                        <div className="image-fullwidth">
                            <img
                                src={translatableResourcePath(ui.image, t)}
                                alt="illustration"
                            />
                        </div>
                    )}

                    <QuestionHeading ui={ui} />
                    <ToggleButtonGroup
                        className={classes(
                            'numerical-scale ',
                            { showLabels: showLabels },
                            {
                                [`score-${
                                    answer &&
                                    answer.userAnswer &&
                                    answer.userAnswer.score
                                }`]: answer && answer.userAnswer,
                            }
                        )}
                        onChange={handleToggle}
                        value={value || (answer && answer.userAnswer.value)}
                        exclusive
                        aria-label="numerical scale"
                    >
                        {ui.options.map((v, i) => {
                            return (
                                <ToggleButton
                                    className={classes(
                                        'numerical-scale-button',
                                        {
                                            'Mui-disabled': !!answer,
                                            answer: !!answer,
                                            question: !answer,
                                        }
                                    )}
                                    key={'select-' + i}
                                    aria-label={v.value}
                                    value={v.value}
                                >
                                    {' '}
                                    {t(v.text)}
                                    <label>{t(v.label)}</label>
                                </ToggleButton>
                            );
                        })}
                    </ToggleButtonGroup>
                </div>
            </div>
        );
    }
);
